// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_UNABLE_TO_LOAD_PHOTO = "Fotografie nelze na\u010d\u00edst. Zkuste jin\u00fd soubor";
export const PHOTO_UPLOAD_UNABLE_TO_LOAD_PHOTO_TRY_ANOTHER_OR_DIFFERENT_SOURCE = "Fotku se nepoda\u0159ilo na\u010d\u00edst. Zkuste vybrat jinou nebo pou\u017eijte jin\u00fd zdroj.";
export const PHOTO_UPLOAD_UNABLE_TO_SCALE_PHOTO = "Fotografii se nepoda\u0159ilo zpracovat. Zkuste jin\u00fd soubor";
